/**
 * Generated from the reviewed dictionaries (seo.home / seo.today / seo.leagues).
 * Server-rendered titles for the translated pages that are open to search engines.
 * Regenerate when those dictionary entries change.
 */
export const INDEXABLE_SEO: Record<string, Record<string, { title: string; description: string }>> = {
  "am": {
    "/": {
      "title": "Statlign፡ በAI የስፖርት ትንበያዎች እና የዛሬ ምክሮች",
      "description": "50 ስልቶች ካሉት የAI ሞተር ግልጽ የስፖርት ትንበያዎች። እያንዳንዱ ምርጫ በእምነት ደረጃ ተደርድሮ ከምክንያቱ ጋር ቀርቧል። በነጻ ይመልከቱ።"
    },
    "/predictions/today": {
      "title": "የዛሬ የእግር ኳስ ትንበያዎች፡ በAI የተደገፉ ምክሮች | Statlign",
      "description": "የዛሬ የእግር ኳስ ትንበያዎች በቀጥታ ይዘመናሉ። ለዛሬ ጨዋታዎች በAI የተመረጡ ምርጫዎች ከእምነት ደረጃ፣ ዕድሎች እና ግልጽ ማብራሪያ ጋር።"
    },
    "/leagues": {
      "title": "የሊግ ትንበያዎች: EPL, ላ ሊጋ እና ሌሎችም",
      "description": "በሊግ የተከፋፈሉ ኤአይ የእግር ኳስ ትንበያዎች — ፕሪሚየር ሊግ፣ ላ ሊጋ፣ ሴሪ ኤ፣ ቡንደስሊጋ፣ ቻምፒየንስ ሊግ እና ሌሎችም። ለእያንዳንዱ የግጥሚያ ሳምንት አዲስ ምክሮች።"
    }
  },
  "ar": {
    "/": {
      "title": "Statlign: توقعات رياضية بالذكاء الاصطناعي ونصائح اليوم",
      "description": "توقعات رياضية شفافة من محرك ذكاء اصطناعي يضم 50 استراتيجية. كل اختيار مرتب حسب الثقة ومعه أسبابه كاملة. مجاناً."
    },
    "/predictions/today": {
      "title": "توقعات مباريات اليوم بالذكاء الاصطناعي | Statlign",
      "description": "توقعات كرة القدم لمباريات اليوم، محدّثة مباشرة. اختيارات مدعومة بالذكاء الاصطناعي مع درجة الثقة والاحتمالات وشرح واضح لكل توقع."
    },
    "/leagues": {
      "title": "توقعات الدوريات: الدوري الإنجليزي والمزيد",
      "description": "توقعات كرة القدم بالذكاء الاصطناعي مجمعة حسب الدوري — الدوري الإنجليزي الممتاز، الدوري الإسباني، الدوري الإيطالي، الدوري الألماني، دوري أبطال أوروبا والمزيد. نصائح جديدة لكل أسبوع مباراة."
    }
  },
  "de": {
    "/": {
      "title": "Statlign: KI-Sportprognosen & Wett-Tipps für heute",
      "description": "Transparente Sportprognosen aus einer KI mit 50 Strategien. Jeder Tipp nach Überzeugung sortiert, jede Begründung offen. Kostenlos einsehbar."
    },
    "/predictions/today": {
      "title": "Fußball-Tipps heute: KI-Wett-Prognosen | Statlign",
      "description": "Fußballprognosen für heute, live aktualisiert. KI-gestützte Tipps für die heutigen Spiele mit Konfidenzwert, Quoten und klarer Begründung."
    },
    "/leagues": {
      "title": "Bundesliga Prognosen: EPL, La Liga & mehr",
      "description": "KI fußball liga prognosen, gruppiert nach Liga – Premier League, La Liga, Serie A, Bundesliga. Frische Tipps für jeden Spieltag."
    }
  },
  "el": {
    "/": {
      "title": "Statlign: αθλητικές προβλέψεις AI & στοιχήματα σήμερα",
      "description": "Διαφανείς αθλητικές προβλέψεις από AI με 50 στρατηγικές. Κάθε επιλογή ταξινομημένη κατά βεβαιότητα, με την αιτιολόγηση. Δωρεάν."
    },
    "/predictions/today": {
      "title": "Προγνωστικά ποδοσφαίρου σήμερα με AI | Statlign",
      "description": "Τα σημερινά προγνωστικά ποδοσφαίρου, με ζωντανή ενημέρωση. Επιλογές AI για τους αγώνες της ημέρας με βαθμό βεβαιότητας, αποδόσεις και εξήγηση."
    },
    "/leagues": {
      "title": "Προγνωστικά Πρωταθλημάτων: EPL, La Liga & Άλλα",
      "description": "Προγνωστικά ποδοσφαίρου AI ομαδοποιημένα ανά πρωτάθλημα — Premier League, La Liga, Serie A, Bundesliga, Champions League και άλλα. Νέες συμβουλές για κάθε αγωνιστική."
    }
  },
  "en": {
    "/": {
      "title": "Statlign: AI Sports Predictions & Betting Tips Today",
      "description": "Transparent, explainable sports picks from a 50-strategy AI engine. Every call ranked by conviction. Every reason on record. Free to inspect."
    },
    "/predictions/today": {
      "title": "Soccer Predictions Today: AI-Backed Betting Tips | Statlign",
      "description": "Today's football predictions and betting tips, updated live. AI-backed picks for matches kicking off today with confidence scores, odds and clear explanations."
    },
    "/leagues": {
      "title": "Predictions by League — EPL, La Liga, Serie A and More",
      "description": "AI football predictions grouped by league. Every match week, every top division — with the historical accuracy that earned each pick."
    }
  },
  "es": {
    "/": {
      "title": "Statlign: pronósticos deportivos con IA y apuestas de hoy",
      "description": "Pronósticos deportivos transparentes de un motor de IA con 50 estrategias. Cada selección ordenada por confianza y con su razonamiento. Gratis."
    },
    "/predictions/today": {
      "title": "Pronósticos de fútbol hoy: apuestas con IA | Statlign",
      "description": "Pronósticos de fútbol para hoy, actualizados en directo. Picks con IA para los partidos de hoy, con nivel de confianza, cuotas y explicación clara."
    },
    "/leagues": {
      "title": "Pronósticos por Liga de Fútbol: Premier, La Liga y Más",
      "description": "Pronósticos de fútbol con IA agrupados por liga: Premier League, La Liga, Serie A, Bundesliga, Champions League y más. Consejos frescos para cada jornada."
    }
  },
  "fil": {
    "/": {
      "title": "Statlign: AI sports predictions at betting tips ngayon",
      "description": "Malinaw na sports predictions mula sa AI na may 50 estratehiya. Bawat pick ay nakaayos ayon sa kumpiyansa, kasama ang dahilan. Libre."
    },
    "/predictions/today": {
      "title": "Hula sa football ngayong araw: AI betting tips | Statlign",
      "description": "Mga hula sa football ngayong araw, live na ina-update. AI picks para sa mga laban ngayon na may confidence score, odds at malinaw na paliwanag."
    },
    "/leagues": {
      "title": "League Predictions: EPL, La Liga & Marami Pa",
      "description": "Mga prediksyon ng AI football na naka-grupo ayon sa liga — Premier League, La Liga, Serie A, Bundesliga, Champions League at marami pa. Bagong tip para sa bawat match week."
    }
  },
  "fr": {
    "/": {
      "title": "Statlign : pronostics sportifs IA et paris du jour",
      "description": "Des pronostics sportifs transparents issus d'un moteur IA à 50 stratégies. Chaque choix classé par confiance, avec son raisonnement. Gratuit."
    },
    "/predictions/today": {
      "title": "Pronostics foot du jour : paris sportifs par IA | Statlign",
      "description": "Les pronostics football du jour, mis à jour en direct. Des choix IA pour les matchs d'aujourd'hui, avec indice de confiance, cotes et explication."
    },
    "/leagues": {
      "title": "Pronostics par ligue de football : EPL, La Liga et plus",
      "description": "Pronostics football IA regroupés par ligue — Premier League, La Liga, Serie A, Bundesliga, Ligue des Champions et plus. Nouveaux conseils pour chaque semaine de match."
    }
  },
  "hi": {
    "/": {
      "title": "Statlign: AI खेल भविष्यवाणियाँ और आज के बेटिंग टिप्स",
      "description": "50 रणनीतियों वाले AI इंजन से पारदर्शी खेल भविष्यवाणियाँ। हर पिक भरोसे के क्रम में, पूरे कारण के साथ। मुफ़्त में देखें।"
    },
    "/predictions/today": {
      "title": "आज की फ़ुटबॉल भविष्यवाणियाँ: AI बेटिंग टिप्स | Statlign",
      "description": "आज के फ़ुटबॉल मैचों की भविष्यवाणियाँ, लाइव अपडेट। आज के मैचों के लिए AI आधारित पिक्स, भरोसे का स्कोर, ऑड्स और साफ़ कारण के साथ।"
    },
    "/leagues": {
      "title": "लीग भविष्यवाणियां: EPL, ला लीगा और अधिक",
      "description": "AI फुटबॉल भविष्यवाणियां लीग के अनुसार समूहीकृत — प्रीमियर लीग, ला लीगा, सीरी ए, बुंडेसलीगा, चैंपियंस लीग और बहुत कुछ। हर मैच सप्ताह के लिए ताज़ा टिप्स।"
    }
  },
  "id": {
    "/": {
      "title": "Statlign: prediksi olahraga AI & tips taruhan hari ini",
      "description": "Prediksi olahraga transparan dari mesin AI 50 strategi. Setiap pilihan diurutkan menurut keyakinan, lengkap dengan alasannya. Gratis."
    },
    "/predictions/today": {
      "title": "Prediksi bola hari ini: tips taruhan AI | Statlign",
      "description": "Prediksi sepak bola hari ini, diperbarui langsung. Pilihan berbasis AI untuk laga hari ini lengkap dengan skor keyakinan, odds, dan penjelasan."
    },
    "/leagues": {
      "title": "Prediksi Liga Bola: EPL, La Liga & Lainnya",
      "description": "Prediksi bola AI dikelompokkan berdasarkan liga — Premier League, La Liga, Serie A, Bundesliga, Liga Champions, dan lainnya. Tips segar untuk setiap pekan pertandingan."
    }
  },
  "it": {
    "/": {
      "title": "Statlign: pronostici sportivi con IA e consigli di oggi",
      "description": "Pronostici sportivi trasparenti da un motore IA con 50 strategie. Ogni scelta ordinata per fiducia, con la motivazione in chiaro. Gratis."
    },
    "/predictions/today": {
      "title": "Pronostici calcio oggi: consigli scommesse con IA | Statlign",
      "description": "I pronostici calcio di oggi, aggiornati in diretta. Consigli IA per le partite di oggi con livello di fiducia, quote e spiegazione chiara."
    },
    "/leagues": {
      "title": "Pronostici per lega calcio: EPL, La Liga e altro",
      "description": "Pronostici calcio AI raggruppati per lega — Premier League, La Liga, Serie A, Bundesliga, Champions League e altro. Consigli freschi per ogni giornata di campionato."
    }
  },
  "ja": {
    "/": {
      "title": "Statlign：AIスポーツ予想と今日のベッティングヒント",
      "description": "50の戦略を持つAIによる透明なスポーツ予想。すべてのピックを確信度順に、根拠付きで公開。無料で確認できます。"
    },
    "/predictions/today": {
      "title": "今日のサッカー予想：AIベッティングのヒント | Statlign",
      "description": "今日のサッカー予想をリアルタイムで更新。本日キックオフの試合をAIが分析し、信頼度・オッズ・根拠をわかりやすく提示します。"
    },
    "/leagues": {
      "title": "リーグ別予想: EPL、ラ・リーガなど",
      "description": "リーグ別にグループ化されたAIサッカー予想 — プレミアリーグ、ラ・リーガ、セリエA、ブンデスリーガ、チャンピオンズリーグなど。毎試合週の新しいヒント。"
    }
  },
  "ko": {
    "/": {
      "title": "Statlign: AI 스포츠 예측과 오늘의 베팅 팁",
      "description": "50가지 전략의 AI 엔진이 만든 투명한 스포츠 예측. 모든 픽을 확신도 순으로, 근거와 함께 공개합니다. 무료로 확인하세요."
    },
    "/predictions/today": {
      "title": "오늘의 축구 예측: AI 베팅 팁 | Statlign",
      "description": "오늘의 축구 예측을 실시간으로 업데이트합니다. 오늘 열리는 경기에 대한 AI 픽을 신뢰도, 배당률, 명확한 근거와 함께 제공합니다."
    },
    "/leagues": {
      "title": "축구 리그 예측: EPL, 라 리가 등",
      "description": "리그별 AI 축구 예측 — 프리미어리그, 라 리가, 세리에 A, 분데스리가, 챔피언스리그 등. 매주 새로운 팁."
    }
  },
  "ms": {
    "/": {
      "title": "Statlign: ramalan sukan AI & tip pertaruhan hari ini",
      "description": "Ramalan sukan telus daripada enjin AI 50 strategi. Setiap pilihan disusun mengikut keyakinan, lengkap dengan sebabnya. Percuma."
    },
    "/predictions/today": {
      "title": "Ramalan bola sepak hari ini: tip pertaruhan AI | Statlign",
      "description": "Ramalan bola sepak hari ini, dikemas kini secara langsung. Pilihan AI untuk perlawanan hari ini dengan skor keyakinan, odds dan penjelasan jelas."
    },
    "/leagues": {
      "title": "Ramalan Liga Bola Sepak — EPL, La Liga & Lain-lain",
      "description": "Ramalan bola sepak AI dikelompokkan mengikut liga. Setiap minggu perlawanan, setiap divisyen teratas — dengan ketepatan sejarah yang menghasilkan setiap pilihan."
    }
  },
  "nl": {
    "/": {
      "title": "Statlign: AI-sportvoorspellingen & wedtips van vandaag",
      "description": "Transparante sportvoorspellingen van een AI met 50 strategieën. Elke keuze gerangschikt op zekerheid, met de onderbouwing erbij. Gratis."
    },
    "/predictions/today": {
      "title": "Voetbalvoorspellingen vandaag: AI-wedtips | Statlign",
      "description": "Voetbalvoorspellingen voor vandaag, live bijgewerkt. AI-tips voor de wedstrijden van vandaag met betrouwbaarheidsscore, odds en heldere uitleg."
    },
    "/leagues": {
      "title": "Competitie voorspellingen: EPL, La Liga & meer",
      "description": "AI voetbal voorspellingen gegroepeerd per competitie — Premier League, La Liga, Serie A, Bundesliga, Champions League en meer. Nieuwe tips voor elke speelweek."
    }
  },
  "pl": {
    "/": {
      "title": "Statlign: typy sportowe AI i porady bukmacherskie",
      "description": "Przejrzyste typy sportowe z silnika AI z 50 strategiami. Każdy typ uszeregowany według pewności i uzasadniony. Za darmo."
    },
    "/predictions/today": {
      "title": "Typy piłkarskie na dziś: zakłady z AI | Statlign",
      "description": "Dzisiejsze typy piłkarskie, aktualizowane na bieżąco. Typy AI na dzisiejsze mecze z poziomem pewności, kursami i jasnym uzasadnieniem."
    },
    "/leagues": {
      "title": "Typy według ligi: EPL, La Liga i więcej",
      "description": "Typy piłkarskie AI pogrupowane według ligi — Premier League, La Liga, Serie A, Bundesliga, Liga Mistrzów i wiele innych. Świeże wskazówki na każdy tydzień meczowy."
    }
  },
  "pt": {
    "/": {
      "title": "Statlign: palpites esportivos com IA e dicas de hoje",
      "description": "Palpites esportivos transparentes de um motor de IA com 50 estratégias. Cada escolha ordenada por confiança, com o motivo explicado. Grátis."
    },
    "/predictions/today": {
      "title": "Palpites de futebol hoje: dicas de apostas com IA | Statlign",
      "description": "Palpites de futebol de hoje, atualizados ao vivo. Dicas com IA para os jogos de hoje, com nível de confiança, odds e explicação clara."
    },
    "/leagues": {
      "title": "Palpites por Liga: EPL, La Liga e Mais",
      "description": "Palpites de futebol de IA agrupados por liga — Premier League, La Liga, Serie A, Bundesliga, Champions League e mais. Dicas frescas para cada semana de jogos."
    }
  },
  "ru": {
    "/": {
      "title": "Statlign: ИИ-прогнозы на спорт и ставки на сегодня",
      "description": "Прозрачные спортивные прогнозы от ИИ с 50 стратегиями. Каждый выбор ранжирован по уверенности и объяснён. Смотреть бесплатно."
    },
    "/predictions/today": {
      "title": "Прогнозы на футбол сегодня: ставки с ИИ | Statlign",
      "description": "Прогнозы на футбольные матчи сегодня, обновляются в реальном времени. Выбор ИИ с уровнем уверенности, коэффициентами и понятным объяснением."
    },
    "/leagues": {
      "title": "Прогнозы по лигам: АПЛ, Ла Лига и другие",
      "description": "ИИ-прогнозы на футбол, сгруппированные по лигам — Премьер-лига, Ла Лига, Серия А, Бундеслига, Лига Чемпионов и другие. Свежие советы на каждую игровую неделю."
    }
  },
  "sv": {
    "/": {
      "title": "Statlign: AI-sporttips och speltips för idag",
      "description": "Transparenta sporttips från en AI med 50 strategier. Varje val rangordnat efter säkerhet, med motiveringen synlig. Gratis att läsa."
    },
    "/predictions/today": {
      "title": "Fotbollstips idag: speltips med AI | Statlign",
      "description": "Dagens fotbollstips, uppdaterade live. AI-baserade val för dagens matcher med säkerhetsnivå, odds och en tydlig förklaring till varje tips."
    },
    "/leagues": {
      "title": "Ligatips: EPL, La Liga & Mer",
      "description": "AI fotbollstips grupperade per liga – Premier League, La Liga, Serie A, Bundesliga, Champions League och mer. Nya tips för varje matchvecka."
    }
  },
  "tr": {
    "/": {
      "title": "Statlign: yapay zekâ spor tahminleri ve günün iddaa",
      "description": "50 stratejili yapay zekâdan şeffaf spor tahminleri. Her seçim güvene göre sıralanır ve gerekçesiyle sunulur. Ücretsiz inceleyin."
    },
    "/predictions/today": {
      "title": "Bugünün maç tahminleri: yapay zekâ iddaa tüyoları | Statlign",
      "description": "Bugünün futbol tahminleri, canlı güncellenir. Bugün oynanacak maçlar için güven puanı, oranlar ve net açıklamalı yapay zekâ seçimleri."
    },
    "/leagues": {
      "title": "Lig Tahminleri: EPL, La Liga ve Daha Fazlası",
      "description": "AI futbol tahminleri liglere göre gruplandırılmıştır — Premier Lig, La Liga, Serie A, Bundesliga, Şampiyonlar Ligi ve daha fazlası. Her maç haftası için yeni ipuçları."
    }
  },
  "vi": {
    "/": {
      "title": "Statlign: dự đoán thể thao AI & mẹo cược hôm nay",
      "description": "Dự đoán thể thao minh bạch từ AI với 50 chiến lược. Mỗi lựa chọn xếp theo độ tin cậy, kèm lý do đầy đủ. Xem miễn phí."
    },
    "/predictions/today": {
      "title": "Dự đoán bóng đá hôm nay: mẹo cược bằng AI | Statlign",
      "description": "Dự đoán bóng đá hôm nay, cập nhật trực tiếp. Lựa chọn từ AI cho các trận hôm nay kèm mức độ tin cậy, tỷ lệ cược và giải thích rõ ràng."
    },
    "/leagues": {
      "title": "Dự đoán giải bóng đá — EPL, La Liga, Serie A và hơn thế nữa",
      "description": "Dự đoán bóng đá AI được nhóm theo giải đấu. Mọi tuần thi đấu, mọi giải đấu hàng đầu — với độ chính xác lịch sử đã mang lại mỗi lựa chọn."
    }
  },
  "zh-TW": {
    "/": {
      "title": "Statlign：AI運動預測與今日投注建議",
      "description": "由50種策略AI引擎產生的透明運動預測。每個推薦依信心排序並附完整理由，免費查看。"
    },
    "/predictions/today": {
      "title": "今日足球預測：AI 投注推薦 | Statlign",
      "description": "今日足球預測，即時更新。針對今天開賽的比賽提供 AI 推薦，附帶信心指數、賠率與清楚的分析理由。"
    },
    "/leagues": {
      "title": "聯賽預測 — 英超、西甲、意甲等",
      "description": "按聯賽分組的 AI 足球預測。每個比賽週，每個頂級聯賽 — 附有支持每個選擇的歷史準確性。"
    }
  },
  "zh": {
    "/": {
      "title": "Statlign：AI体育预测与今日投注建议",
      "description": "由50种策略AI引擎生成的透明体育预测。每个推荐按信心排序并附完整理由，免费查看。"
    },
    "/predictions/today": {
      "title": "今日足球预测：AI 投注推荐 | Statlign",
      "description": "今日足球预测，实时更新。针对今天开赛的比赛提供 AI 推荐，附带信心指数、赔率和清晰的分析理由。"
    },
    "/leagues": {
      "title": "联赛预测 — 英超、西甲、意甲等",
      "description": "按联赛分组的 AI 足球预测。每周的每一场比赛，每个顶级联赛 — 都有其赢得每个精选的历史准确性。"
    }
  }
};
